import styled from "@emotion/styled";

export const TruckOrdersTableWrapper = styled.div(({ theme }) => ({
	width: "100%",
	overflowX: "auto"
}));
